export class CreateVehicleModel {
  public veiculoModeloId = 0
  public placa = ''
  public isFrota = ''

}

export class EditVehicleModelModel {
  public id = 0
  public descricao = ''
  public tipoVeiculoId = 0
}

export class DeleteVehicleModelModel {
  public id = 0
  public descricao = ''
}

export class SearchVehicleModelModel {
  public modelo = ''
}

export class CreateVehicleModelResponse {
  public response: any
}
export class EditVehicleModelResponse {
  public response: any
}
export class DeleteVehicleModelResponse {
  public response: any
}
export class PagedVehicleModelResponse {
  public response: any
}

class Vehicle {
  public VeiculoModeloId = 0
  public Placa: any
  public IsFrota = ''
  public FornecedorId: any
  public Documentos = new Array<Documents>()

}

class Documents {
  public veiculoId?: any
  public descricao = ''
  public tipoDocId = 0
  public arquivo: any
}

export class DocumentVehicleUpload {
  public document = new Documents


  public toFormData(): FormData {
    const formData = new FormData()

    formData.append('VeiculoId', this.document.veiculoId)
    formData.append('Descricao', this.document.descricao)
    formData.append('TipoDocId', this.document.tipoDocId.toString())
    if (this.document.arquivo) {
      formData.append('Arquivo', this.document.arquivo)
    }

    return formData
  }
}

export class VehicleCreateModel {
  public Vehicle = new Vehicle
  public toFormData(): FormData {
    const formData = new FormData()
    formData.append('VeiculoModeloId', this.Vehicle.VeiculoModeloId.toString())
    formData.append('Placa', this.Vehicle.Placa)
    formData.append('IsFrota', this.Vehicle.IsFrota)
    formData.append('FornecedorId', this.Vehicle.FornecedorId.toString())

    if (this.Vehicle.Documentos) {
      this.Vehicle.Documentos.forEach((doc, index) => {
        formData.append(`Documentos[${index}].descricao`, doc.descricao)
        formData.append(`Documentos[${index}].tipoDocId`, doc.tipoDocId.toString())
        if (doc.arquivo) {
          formData.append(`Documentos[${index}].arquivo`, doc.arquivo)
        }
      })
    }
    return formData
  }
}